import { useState, useEffect } from "react";
import { AuthContext } from "../contexts/AuthContext";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";


function AuthProvider({ children }) {
    const location = useLocation();
    const navigate = useNavigate();

    const localStorageUser = localStorage.getItem("user");
    const initalUser = localStorageUser ? JSON.parse(localStorageUser) : null;
    let [user, setUser] = useState(initalUser);
    let [firstName, setFirstName] = useState(initalUser && initalUser.firstName ? initalUser.firstName : "");
    let [lastName, setLastName] = useState(initalUser && initalUser.lastName ? initalUser.lastName : "");
    let [avatar, setAvatar] = useState(initalUser && initalUser.avatar ? initalUser.avatar : "");

    const fetchUsers = async () => {
    try {
      if (!initalUser?.jwtToken) return;

      const URL = process.env.REACT_APP_API_URL + "/me";

      const response = await axios.post(
        URL,
        {},
        {
          headers: {
            Authorization: `Bearer ${initalUser.jwtToken}`,
          },
        }
      );

       if (response.data && response.data.userStatus === "Inactive") {
         signout(() => {
          localStorage.setItem("logoutMessage", "Your account is inactive. Please contact support.");
            navigate("/login");
          });
          return;
      }


       const updatedUser = {
            ...response.data,
            jwtToken: initalUser.jwtToken
        };

        setUser(updatedUser);

        localStorage.setItem("user", JSON.stringify(updatedUser));

    } catch (error) {
        console.error("Error fetching user:", error);

        const message = error.response?.data?.message || error.response?.data || error.message;

        if (message === "Your account session has expired. Please contact support.") {
          signout(() => {
          localStorage.setItem("logoutMessage", message);
            navigate("/login");
          });
          return;
        }
      }
  };

  useEffect(() => {
    fetchUsers();

    const interval = setInterval(() => {
      const storedUser = localStorage.getItem("user");

      if (!storedUser) {
        setUser(null);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [location.pathname]);

    let signin = (newUser, callback) => {
        localStorage.setItem('user', JSON.stringify(newUser));
        setUser(newUser);
        setFirstName(newUser.firstName ? newUser.firstName : "")
        setLastName(newUser.lastName ? newUser.lastName : "")
        setAvatar(newUser.avatar ? newUser.avatar : "")
        callback();

    };

    let updateUser = (userObj, callback) => {
        const newUser = { ...user, ...userObj };
        localStorage.setItem('user', JSON.stringify(newUser));
        setUser(newUser);
        setFirstName(newUser && newUser.firstName ? newUser.firstName : firstName)
        setLastName(newUser && newUser.lastName ? newUser.lastName : lastName)
        setAvatar(newUser && newUser.avatar ? newUser.avatar : avatar)
        callback();
    }

    let signout = (callback) => {
        localStorage.removeItem('user');
        setUser(null);
        callback();

    };

    let value = { user, firstName, lastName, avatar, signin, signout, updateUser };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthProvider;